import { Button, DialogActions } from "@mui/material";
import { isEmpty } from "lodash-es";
import { type FC, useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { EditorLinkData } from "../../plugins/toolbar/hooks/use-link-button-on-click";
import type { Link } from "./types";

export const LinkFormActions: FC<{
  onRemove: () => void;
  onCancel: () => void;
  data: Pick<EditorLinkData, "mode" | "url">;
}> = ({ onRemove, onCancel, data: { mode, url } }) => {
  const { t } = useTranslation();

  const { reset } = useFormContext<Link>();

  const remove = useCallback(() => {
    onRemove();
    reset();
  }, [onRemove, reset]);

  const cancel = useCallback(() => {
    onCancel();
    reset();
  }, [onCancel, reset]);

  return (
    <DialogActions sx={{ pt: 0 }}>
      {mode === "edit" && !isEmpty(url) && (
        <Button
          data-analytics-id="lexical-link-dialog-remove"
          type="button"
          onClick={remove}
          color="warning"
        >
          {t("Remove Link")}
        </Button>
      )}
      <Button
        data-analytics-id="lexical-link-dialog-cancel"
        type="button"
        onClick={cancel}
        color="error"
      >
        {t("Cancel")}
      </Button>
      <Button data-analytics-id="lexical-link-dialog-confirm" type="submit" color="success">
        {t("Confirm")}
      </Button>
    </DialogActions>
  );
};
